import React, { useEffect, useState } from "react";
import BuildersImg from "../assets/img/images/web1.jpg";
import ToolsImg from "../assets/img/images/web-design.jpg";
import OtherToolsImg from "../assets/img/images/web2.jpg";


function Webdesign() {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const containerStyle = {
    fontFamily: "'Poppins', sans-serif",
    padding: "40px 20px",
    backgroundColor: "#f9fafb",
    color: "#333",
  };

  const gridStyle = {
    display: "grid",
    gridTemplateColumns: isMobile ? "1fr" : "1fr 1fr", // For mobile, 1 column; for desktop, 2 columns
    gap: "30px",
    marginTop: "30px",
    maxWidth: "80%",
    margin: "30px auto",
  };

  const cardStyle = (bgColor = "#7620ff") => ({
    backgroundColor: bgColor,
    borderRadius: "10px",
    padding: "20px",
    maxWidth: "90%",
  });

  const imageStyle = {
    width: "100%",
    height: "200px",
    objectFit: "contain",
    borderRadius: "10px",
    marginBottom: "15px",
    backgroundColor: "#fff",
  };

  const descriptionStyle = {
    textAlign: "center",
    margin: "20px auto 0",
    fontSize: "1rem",
    lineHeight: "1.6",
    color: "#555",
  };

  return (
    <div style={containerStyle}>
      <h1 style={{ textAlign: "center", color: "#7620ff", marginTop: "4rem" }}>
        Web Design Tools & Builders
      </h1>

      <p style={descriptionStyle}>
        <strong>Web Design:</strong> There are several free website design
        software options, including <em>Wix</em>, <em>Google Sites</em>, and{" "}
        <em>Figma</em>.
      </p>

      <div style={gridStyle}>
        <div style={cardStyle("#ffd665")}>
          <img src={BuildersImg} alt="Website Builders" style={imageStyle} />
          <h3>Website Builders</h3>
          <ul>
            <li><strong>Wix:</strong> Simple website builder with templates and SEO tools.</li>
            <li><strong>Google Sites:</strong> Free builder ideal for basic sites.</li>
            <li><strong>Squarespace:</strong> Online builder with modern templates.</li>
            <li><strong>Webflow:</strong> Visual builder with powerful features.</li>
            <li><strong>Web.com:</strong> Another accessible online builder.</li>
          </ul>
        </div>

        <div style={cardStyle("#c4a0ff")}>
          <img src={ToolsImg} alt="Design Tools" style={imageStyle} />
          <h3>Design Tools</h3>
          <ul>
            <li><strong>Figma:</strong> Collaborative wireframing tool for beginners.</li>
            <li><strong>Sketch:</strong> Vector-based tool for Mac users.</li>
            <li><strong>Canva:</strong> Easy-to-use online graphic design tool.</li>
            <li><strong>Google Web Designer:</strong> Versatile tool by Google.</li>
          </ul>
        </div>

        <div style={cardStyle("#e1bff4")}>
          <img src={OtherToolsImg} alt="Other Tools" style={imageStyle} />
          <h3>Other Tools</h3>
          <ul>
            <li><strong>Content Hub:</strong> All-in-one web design tool for beginners.</li>
            <li><strong>WordPress:</strong> Popular open-source CMS.</li>
            <li><strong>Fluid UI:</strong> Lightweight prototyping tool.</li>
            <li><strong>Dorik AI:</strong> AI-powered free design software.</li>
          </ul>
        </div>
      </div>
    </div>
  );
}

export default Webdesign;
